import React from 'react';
import './shimmer.css';

export default function ShimmerBoardList() {
  return (
    <>
      {Array.from({ length: 5 }).map((el, i) => {
        return <div className="GufEKeXXKVJ9bq"></div>;
      })}
    </>
  );
}
